/* KOMTO redesign (BAN-179): search.
 * - Cancel (S-10): closes the full-screen results on phones, clears the field and folds the
 *   header search bar back.
 * - Search page (SR-01): the result-type tabs scroll to their block and mark themselves current.
 */
(() => {
  if (window.komtoSearchReady) return;
  window.komtoSearchReady = true;

  document.addEventListener('click', (event) => {
    const cancel = event.target.closest('.js-komto-search-cancel');
    if (!cancel) return;
    const search = cancel.closest('predictive-search');
    if (!search) return;
    const input = search.querySelector('.js-search-input');
    if (input) {
      input.value = '';
      input.setAttribute('value', '');
      input.blur();
    }
    search.removeAttribute('results');
    if (typeof search.close === 'function') search.close();
    const header = cancel.closest('store-header');
    const toggle = header && header.classList.contains('search-is-visible') ? header.querySelector('.js-show-search') : null;
    if (toggle) toggle.click();
  });
})();

/* Search results page: pages and collections under the grid, with counts on the type links */
(() => {
  const box = document.querySelector('[data-komto-search-extras]');
  if (!box || box.dataset.loaded) return;
  box.dataset.loaded = 'true';
  const terms = box.dataset.terms;
  if (!terms) return;
  const params = new URLSearchParams();
  params.set('q', terms);
  params.set('resources[type]', 'page,article,collection');
  params.set('resources[limit]', '6');
  params.set('section_id', 'komto-search-extras');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(`${root}search/suggest?${params.toString()}`)
    .then((response) => (response.ok ? response.text() : ''))
    .then((html) => {
      if (!html) return;
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;
      const extras = tmpl.content.querySelector('.komto-sx');
      if (!extras) return;
      const counts = { pages: Number(extras.dataset.pages || 0), collections: Number(extras.dataset.collections || 0) };
      if (counts.pages + counts.collections === 0) return;
      box.appendChild(extras);
      box.hidden = false;
      Object.keys(counts).forEach((type) => {
        const link = document.querySelector(`[data-komto-type-link="${type}"]`);
        if (!link || !counts[type]) return;
        const count = link.querySelector('[data-komto-count]');
        if (count) count.textContent = counts[type];
        link.hidden = false;
      });
    })
    .catch(() => {});
})();
